import * as React from "react";

import {handlebar}     from "@Common/libs/handlebars/handlebars";
import {numeralHelper} from "@Common/libs/handlebars/numeral-helper";
import {he}            from "@Common/libs/he/he";
import {cs}            from "@Common/react/chain-services";
import {UseState}      from "@Common/react/use-state";

const Handlebars = handlebar.create();
numeralHelper.registerHelpers(Handlebars);

export const getInfoTip = (textField, sourceData) => {
    return textField.infoTip && textField.infoTip !== "not found" && getBindingResults(sourceData, textField.infoTip) && cs(
        ["show", (_, next) => UseState({next})],
        ({show})=> (
            <i {...{
                "xd-qa-type": "icon",
                "xd-qa-name": "info",
                className: "infoTip",
                onClick: () => show.onChange(!show.value),
            }}>
                {!!show.value && (
                    <div>
                        <div className='infoTipText' dangerouslySetInnerHTML={{ __html: getBindingResults(sourceData, textField.infoTip) }}/>
                    </div>
                )}
            </i>
        )
    )
};

const getBindingResults = (o, n) => {
    let res = Handlebars.compile(n, { noEscape: true });
    let result = he.decode(res(o));
    return result;
};
